const SubHeader = ({ text }) =>
  <div className="flex items-center">
    <p className="section-text-n text-rouge">
      {text}
    </p>
  </div>

export default SubHeader;